import { render, staticRenderFns } from "./PageContactUs.vue?vue&type=template&id=012ac3ca&scoped=true"
import script from "./PageContactUs.vue?vue&type=script&lang=js"
export * from "./PageContactUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ac3ca",
  null
  
)

export default component.exports